import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from 'react-redux';
import { CampaignType } from './campaign-type';
import { useNavigate, useRouteParams } from '../../../../../infra/routing';
import { saveCampaignTypeSelection } from './go-to-next-step';
import { useSession } from '../../../../../infra/session';
import { useBreakpoints } from '../../../../../infra/dls/hooks/use-get-breakpoints';
import { useCanSeePromotion } from '../../../hooks/use-can-see-promotion';
import { t } from '../../../../../infra/i18n';
export var CampaignTypeContainer = function () {
    var store = useStore();
    var navigate = useNavigate();
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var campaignId = useRouteParams().campaignId;
    var session = useSession().data;
    var canSeePromotion = useCanSeePromotion(campaignId);
    var comingSoonLabel = isMobileOrSmaller
        ? t('engage:campaign_builder.coming_soon.short')
        : t('engage:campaign_builder.coming_soon.long');
    var handleCampaignTypeSelection = function (newType) {
        saveCampaignTypeSelection({ store: store, navigate: navigate, newType: newType, campaignId: campaignId, session: session });
    };
    return (_jsx(CampaignType, { onSelect: handleCampaignTypeSelection, comingSoonLabel: comingSoonLabel, displayStepTitle: !isMobileOrSmaller, canSeePromotion: canSeePromotion }));
};
